module.exports = __webpack_public_path__ + "static/media/delu_jackson.8232d27c.png";